import React, { useEffect } from 'react';
import { LabelInput, TextArea } from 'modules/v2/common/AtomicDesign/atoms';
import { DropdownInput } from 'modules/v2/common/components';

import { FormData } from 'modules/v2/pages/TemplatesBuilder/utils/setupModalUtils';

interface Step4Props {
  formData: FormData;
  onFormDataChange: (data: any) => void;
}

export const isStep4Valid = (formData: FormData) => {
  return formData.ctaText && (formData.ctaText !== 'Let me write my own' || formData.customctaText);
};

const PlusIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_31283_3341)">
      <circle cx="8.00016" cy="7.9987" r="6.66667" stroke="#252525" strokeWidth="1.5"/>
      <path d="M7.25049 10.4014V8.75195H5.6001C5.18601 8.75195 4.8503 8.416 4.8501 8.00195C4.8501 7.58774 5.18588 7.25195 5.6001 7.25195H7.25049V5.60156C7.25049 5.18735 7.58627 4.85156 8.00049 4.85156C8.41452 4.85177 8.75049 5.18748 8.75049 5.60156V7.25195H10.3999C10.8141 7.25195 11.1499 7.58774 11.1499 8.00195C11.1497 8.416 10.814 8.75195 10.3999 8.75195H8.75049V10.4014C8.75049 10.8155 8.41452 11.1512 8.00049 11.1514C7.58627 11.1514 7.25049 10.8156 7.25049 10.4014Z" fill="#252525"/>
    </g>
    <defs>
      <clipPath id="clip0_31283_3341">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const Step4: React.FC<Step4Props> = ({ formData, onFormDataChange }) => {
  const handleInputChange = (field: string, value: string) => {
    onFormDataChange({ ...formData, [field]: value });
  };

  const ctaOptions = [
    { value: 'link-in-bio', label: <div>🔗  Click the link in my bio to request a free copy of my book!</div>, rawValue: '🔗 Click the link in my bio to request a free copy of my book!' },
    // eslint-disable-next-line quotes
    { value: 'dm-book', label: <div>📩  DM me the word "Book" and I'll send you a copy!</div>, rawValue: `📩 DM me the word "Book" and I'll send you a copy!` },
    { value: 'text-number', label: <div>📲  Text me at {formData?.phone}</div>, rawValue: `📲 Text me at ${formData?.phone}`  },
    // eslint-disable-next-line quotes
    { value: 'comment-info', label: <div>💬  Comment "INFO" and I'll reach out</div>, rawValue: `💬 Comment "INFO" and I'll reach out` },
    { value: 'get-copy', label: <div>📘  Get your free copy at {formData?.website.replace('https://', '').replace('http://', '')}</div>, rawValue: `📘 Get your free copy at ${formData?.website.replace('https://', '').replace('http://', '')}`  },
    { value: 'book-call', label: <div>✅  Let's connect—book a call today!</div>, rawValue: "✅ Let's connect—book a call today!" },
    { value: 'write-own', label: <div className="flex items-center">{PlusIcon} <span className='ml-1.5'>Let me write my own</span></div>, rawValue: 'Let me write my own' },
  ];

  const mountCTAOptions = () => {
    const mapOption = (option, notAllowed = false) => ({
      id: option.value,
      key: option.value,
      value: option.rawValue,
      label: option.label,
      notAllowed
    });

    return ctaOptions.map((option) => mapOption(option));
  };

  useEffect(() => {
    const foundCTA = ctaOptions.find((option) => option.rawValue === formData.ctaText);

    if (!formData.ctaText)
      formData.ctaText = '🔗 Click the link in my bio to request a free copy of my book!';
    else if (!foundCTA) {
      formData.customctaText = formData.ctaText;
      formData.ctaText = 'Let me write my own';
    }

  }, []);

  return (
    <div className="space-y-4">
        <div>
          <LabelInput required>
            Choose your Social Media Call to Action
          </LabelInput>
          <DropdownInput
            placeholder="Choose your social media call-to-action"
            selectedValues={formData.ctaText}
            onSelect={(value) => {
              formData.customctaText = '';

              handleInputChange('ctaText', value);
            }}
            options={mountCTAOptions()}
            dropdownClasses='relative'
          />
        </div>

        {Boolean(formData.ctaText === 'Let me write my own') && <div>
          <TextArea
            value={formData.customctaText}
            onChange={(e) => handleInputChange('customctaText', e.target.value)}
            placeholder="Enter your custom Call To Action"
            title="Your custom Call to Action text"
            rows={3}
            maxLength={140}
            showCharacterCount
          />
        </div>}
    </div>
  );
};

